import aamiliLogoWebp from "@/assets/optimized/brand-aamili.webp";
import bearLabelLogoWebp from "@/assets/optimized/brand-bearlabel.webp";
import gzLogoWebp from "@/assets/optimized/brand-gz.webp";
import hrxLogoWebp from "@/assets/optimized/brand-hrx.webp";
import myntraLogoWebp from "@/assets/optimized/brand-myntra.webp";
import roadsterLogoWebp from "@/assets/optimized/brand-roadster.webp";

const brands = [
    { name: "Myntra", logo: myntraLogoWebp, width: 294, height: 196 },
    { name: "HRX", logo: hrxLogoWebp, width: 293, height: 196 },
    { name: "Roadster", logo: roadsterLogoWebp, width: 189, height: 126 },
    { name: "aamili", logo: aamiliLogoWebp, width: 283, height: 79 },
    { name: "The Bear Label", logo: bearLabelLogoWebp, width: 263, height: 79 },
    { name: "GZ", logo: gzLogoWebp, width: 224, height: 196 },
];

const BrandsMarquee = () => {
    return (
        <section className="py-10 sm:py-12 overflow-hidden mx-0 sm:mx-12 md:mx-24 lg:mx-[300px]">
            <div className="container mx-auto px-6 relative">
                {/* Fade edges */}
                <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-12 sm:w-24 bg-gradient-to-r from-background to-transparent z-10" />
                <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-12 sm:w-24 bg-gradient-to-l from-background to-transparent z-10" />

                <div className="flex items-center gap-8 sm:gap-12 opacity-40 animate-marquee whitespace-nowrap">
                    {[...brands, ...brands, ...brands].map((brand, i) => {
                        const size = ["aamili"].includes(brand.name)
                            ? "h-5 sm:h-7"
                            : brand.name === "The Bear Label"
                              ? "h-4 sm:h-5"
                              : "h-8 sm:h-12";
                        return (
                            <img
                                key={`${brand.name}-${i}`}
                                src={brand.logo}
                                alt={brand.name}
                                width={brand.width}
                                height={brand.height}
                                loading="lazy"
                                decoding="async"
                                className={`${size} w-auto object-contain shrink-0`}
                            />
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default BrandsMarquee;
